import {
  ArrayMaxSize,
  ArrayMinSize,
  IsArray,
  IsBoolean,
  IsIn,
  IsNotEmpty,
  IsOptional,
  IsString,
  MaxLength,
  ValidateIf,
} from 'class-validator';
import {
  DEADLINE_DOMAIN_VALUES,
  DEADLINE_TITLE_MAX_LENGTH,
  type DeadlineDomainValue,
} from './deadline.constants';
import { CONSULTANT_BULK_MAX_TENANTS } from './deadline-management.constants';
import { DeadlineRecurrenceFormDto } from './deadline-recurrence-form.dto';

/**
 * Valori del form "Nuova scadenza" (client): piatti, con la risposta sulla ricorrenza
 * esplicita; `toBulkCreateDeadlinesDto` li trasforma nel body `{ tenantIds, payload }`.
 */
export class ConsultantDeadlineFormDto extends DeadlineRecurrenceFormDto {
  @IsArray()
  @ArrayMinSize(1)
  @ArrayMaxSize(CONSULTANT_BULK_MAX_TENANTS)
  @IsString({ each: true })
  tenantIds!: string[];

  @IsString()
  @IsNotEmpty()
  documentTypeId!: string;

  /** Vero per il tipo "Altro": il titolo libero diventa obbligatorio. */
  @IsBoolean()
  titleRequired!: boolean;

  @ValidateIf((form: ConsultantDeadlineFormDto) => form.titleRequired === true)
  @IsString()
  @IsNotEmpty()
  @MaxLength(DEADLINE_TITLE_MAX_LENGTH)
  title?: string;

  @IsOptional()
  @IsIn(DEADLINE_DOMAIN_VALUES)
  domain?: DeadlineDomainValue;

  @IsBoolean()
  clientCanUpload!: boolean;

  @IsBoolean()
  requestClientSignature!: boolean;
}
